const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
const MOBILE_BREAKPOINT = 1024;

export function initNavigation() {
    const header = document.querySelector('.header');
    if (!header) return;

    const opener = header.querySelector('.menu-opener');
    const menuDrop = header.querySelector('.menu-drop');
    if (!opener || !menuDrop) return;

    const isOpen = () => document.body.classList.contains('nav-active');
    const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

    function getFocusable() {
        return [...menuDrop.querySelectorAll(FOCUSABLE)];
    }

    // On desktop the menu is always visible — never pull items from tab order
    function setFocusable(enabled) {
        const shouldDisable = !enabled && isMobile();
        getFocusable().forEach(el => {
            if (shouldDisable) {
                el.setAttribute('tabindex', '-1');
            } else {
                el.removeAttribute('tabindex');
            }
        });
    }

    function openMenu() {
        document.body.classList.add('nav-active');
        opener.setAttribute('aria-expanded', 'true');
        opener.setAttribute('aria-label', 'Close navigation menu');
        menuDrop.setAttribute('aria-hidden', 'false');
        setFocusable(true);

        // Double rAF — wait for visibility: visible to apply before focusing
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const focusable = getFocusable();
                if (focusable.length) focusable[0].focus();
            });
        });
    }

    function closeMenu() {
        document.body.classList.remove('nav-active');
        opener.setAttribute('aria-expanded', 'false');
        opener.setAttribute('aria-label', 'Open navigation menu');
        menuDrop.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        setFocusable(false);
        opener.focus();
    }

    // Init — menu closed, items removed from tab order
    setFocusable(false);

    opener.addEventListener('click', () => {
        isOpen() ? closeMenu() : openMenu();
    });

    // Global keydown — intercepts Tab even if focus escaped menuDrop
    document.addEventListener('keydown', (e) => {
        if (!isOpen() || !isMobile()) return;

        // WCAG 2.1.2 — Escape always closes
        if (e.key === 'Escape') {
            closeMenu();
            return;
        }

        if (e.key !== 'Tab') return;

        const focusable = getFocusable();
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        // If focus is outside menuDrop, redirect into menu
        if (!menuDrop.contains(active) && active !== opener) {
            e.preventDefault();
            (e.shiftKey ? last : first).focus();
            return;
        }

        // WCAG 2.1.1 — cycle Tab within menu
        if (e.shiftKey && active === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && active === last) {
            e.preventDefault();
            first.focus();
        }
    });

    // Close on overlay click
    menuDrop.addEventListener('click', (e) => {
        if (e.target === menuDrop) closeMenu();
    });

    // Close when resized back to desktop
    window.addEventListener('resize', () => {
        if (isOpen() && window.innerWidth >= MOBILE_BREAKPOINT) closeMenu();
    });
}
